import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import SectionTitle from '../../elements/sectionTitle/SectionTitle';
import CommunityTopics from '../../components/community/CommunityTopics';
import CommunityHero from '../../components/community/CommunityHero';
import Separator from '../../elements/separator/Separator';
import CommunityAccordion from '../../elements/accordion/CommunityAccordion';
import CommunityCallToAction from '../../components/community/CommunityCallToAction';
import CommunityPricingTwo from '../../components/community/CommunityPricingTwo';
import VideoOne from '../../elements/video/VideoOne';
import VideoTwo from '../../elements/video/VideoTwo';
import Video from '../../elements/video/Video';
import CommunityVideo from '../../elements/video/CommunityVideo';
import ScrollAnimation from 'react-animate-on-scroll';
import CommunityPriceUpdate from '../../components/community/CommunityPriceUpdate';





const Community = () => {
    return (
        <>
            <SEO title="Community" />
            <main className="page-wrapper">
                {/* <HeaderTopBar /> */}
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                <CommunityHero />
                {/* <div className="rn-service-area rn-section-gap ">
                    <div className='container'>
                        <CommunityVideo />
                    </div>
                </div> */}

                <div className="rn-service-area rn-section-gap">
                    <div className='container'>
                        <style>
                            {`
          h3,h2 {
            color: ;
          }
        `}
                        </style>
                        <div className='px-5 mx-5'>
                            <h2>About PWU Community</h2>

                            <h3>Starter Club – For Action-Takers Starting Out</h3>
                            <p>Jumpstart your journey with access to proven content, live mentorship, and a powerful community. Perfect for beginners building strong life, business, and income foundations.</p>

                            <h3>Rich Club – For Growth-Focused Entrepreneurs</h3>
                            <p>Designed for serious doers who want consistent results, strategic audits, and investor-ready guidance. Ideal for entrepreneurs aiming to grow with structure and support.</p>

                            <h3>Elite Club – For Leaders Ready to Multiply</h3>
                            <p>Step into elite-level mentorship, personalized strategies, and investor networking. Built for business owners scaling their systems, teams, and long-term impact.</p>

                            <h3>Capital Club – For Visionaries Seeking Wealth & Legacy</h3>
                            <p>Gain exclusive access to high-return partnerships, direct mentorship, and investor circles. Perfect for those ready to grow wealth, influence, and long-term business assets.</p>

                            <h2>Community Outcomes & Prices</h2>

                            <h3>PWU Starter Club – 1,25,000 BDT (One-Time Payment | Non-Refundable)</h3>
                            <p><strong>What You Will Get:</strong></p>
                            <ul>
                                <li>12 Months Full Access to the PWU Premium Content Section Worth 20000+ BDT</li>
                                <li>1-Year Community Membership with like-minded entrepreneurs and experts (Unlimited Value)</li>
                                <li>12+ Group Live Sessions (online/offline) with Jahid Hasan & guest mentors Worth 600000+ BDT</li>
                                <li>1 Personalized Strategy Audits to review and upgrade your Life, Business & Income roadmap Worth 1,25,000+ BDT</li>
                                <li>12 Months Group Mentorship for ongoing guidance and support</li>
                                <li>Launch Code Training Access to master your business launch and marketing Worth 1,25,000+ BDT</li>
                            </ul>
                            <p><strong>Total Value:</strong> 10,00,000 BDT<br/><strong>Join Now:</strong> 1,25,000</p>

                            <h3>PWU Rich Club – 12,00,000+ BDT (One-Time Payment | Non-Refundable)</h3>
                            <p><strong>What You Will Get:</strong></p>
                            <ul>
                                <li>12 Months Full Access to the PWU Premium Content Section Worth 20,000+ BDT</li>
                                <li>1-Year Community Membership with like-minded entrepreneurs and experts (Unlimited Value)</li>
                                <li>12+ Group Live Sessions (online/offline) with Jahid Hasan & guest mentors Worth 6,00,000+ BDT</li>
                                <li>2 Personalized Strategy Audits to review and upgrade your Life, Business & Income roadmap Worth 2,00,000+ BDT</li>
                                <li>12 Months Group Mentorship for ongoing guidance and support</li>
                                <li>One to One Exclusive Mentorship Support from Jahid for 12 months Worth 30,00,000+ BDT</li>
                                <li>Launch Code Training Access to master your business launch and marketing Worth 1,00,000+ BDT</li>
                                <li>Business Partnership Opportunity for 3 Years & Expected Financial Return 2,70,000 BDT - 5,40,000 BDT</li>
                            </ul>
                            <p><strong>Total Value:</strong> 45,00,000 BDT<br/><strong>Join Now:</strong> 12,00,000 BDT</p>

                            <h3>PWU Elite Club – 30,00,000+ BDT (One-Time Payment | Non-Refundable)</h3>
                            <p><strong>What You Will Get:</strong></p>
                            <ul>
                                <li>12 Months Full Access to the PWU Premium Content Section Worth 20,000+ BDT</li>
                                <li>1-Year Community Membership with like-minded entrepreneurs and experts (Unlimited Value)</li>
                                <li>12+ Group Live Sessions (online/offline) with Jahid Hasan & guest mentors Worth 6,00,000+ BDT</li>
                                <li>3 Personalized Strategy Audits to review and upgrade your Life, Business & Income roadmap Worth 3,00,000+ BDT</li>
                                <li>12 Months Group Mentorship for ongoing guidance and support</li>
                                <li>One to One Exclusive Mentorship Support from Jahid for 12 months Worth 30,00,000+ BDT</li>
                                <li>Launch Code Training Access to master your business launch and marketing Worth 1,00,000+ BDT</li>
                                <li>Growth Code Training Access to set up your business sales system, marketing funnel and Establishing Authority Brand Positioning Worth 3,00,000+ BDT</li>
                                <li>Business Partnership Opportunity for 5 Years & Expected Financial Return 6,75,000 BDT - 13,50,000 BDT</li>
                            </ul>
                            <p><strong>Total Value:</strong> 55,00,000 BDT<br/><strong>Join Now:</strong> 25,00,000 BDT</p>

                            <h3>PWU Capital Club – 12+ Million BDT (One-Time Payment | Non-Refundable)</h3>
                            <p><strong>What You Will Get:</strong></p>
                            <ul>
                                <li>10 years Full Access to the PWU Premium Content Section, Worth 2,50,000+</li>
                                <li>10 years Community Membership with like-minded entrepreneurs and experts worth 10,00,000+</li>
                                <li>10 years Group Live Sessions (online/offline) with Jahid Hasan & guest mentors (Unlimited Value)</li>
                                <li>At least 40 Personalized Strategy Audits over 10 years to review and upgrade your Life, Business & Income roadmap, worth 60,00,000+ BDT</li>
                                <li>10 years Group Mentorship for ongoing guidance and support</li>
                                <li>10 years One to One Exclusive Mentorship Support from Jahid (Unlimited Value)</li>
                                <li>10 years Access to All Flagship Training Programme of PWU to master your Life, Business & Income Development (Unlimited Value)</li>
                                <li>Business Partnership Opportunity for 10 Years & Expected Financial Return 90,00,000 BDT - 18,00,0000 BDT</li>
                            </ul>
                            <p><strong>Total Value:</strong> 100+ million BDT<br/><strong>Join Now:</strong> 12 million BDT</p>
                        </div>


                    </div>

                </div>


                {/* Start Service Area  */}
                {/* <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-left"
                                    radiusRounded=""
                                    subtitle="What we can do for you"
                                    title="Popular Subjects"
                                    description="Unlock the secrets of wealth accumulation and strategic investment in our premier course. <br />Dive deep into financial literacy, business acumen, and market insights to sculpt your path to prosperity."
                                />
                            </div>
                        </div>
                        <CommunityTopics
                            serviceStyle="service__style--1 bg-color-blackest radius mt--25 rbt-border"
                            textAlign="text-start"
                        />
                    </div>
                </div> */}
                {/* End Service Area  */}




                {/* Start Elements Area  Community Pricing*/}
                <div className="rwt-advance-tab-area rn-section-gap" id='join'>
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="COMMUNITY PRICING"
                                    // title = "Start Learning and Graw With Our Community"
                                    description=""
                                />
                            </div>
                        </div>
                        <CommunityPriceUpdate />
                    </div>
                </div>
                {/* End Elements Area  */}


                {/* Start Elements Call To Action Area  */}
                <div className="rwt-callto-action-area rn-section-gapBottom">
                    <div className="wrapper">
                        <CommunityCallToAction />
                    </div>
                </div>
                {/* End Elements Area  */}


                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default Community
